import { defineMessages } from 'react-intl';

export const protocolsListViewMessages = defineMessages({
  savedShortcuts: {
    defaultMessage: 'Saved Shortcuts',
    id: '9sbHRovqSB',
    description: 'Dialog title for the list of user-saved protocol shortcuts',
  },
  savedShortcutsDescription: {
    defaultMessage: 'Your saved shortcuts for quick access during consultations',
    id: 'KBycLSJiVV',
    description: 'Subtitle explaining the saved shortcuts list in the protocols modal',
  },
  addShortcutLower: {
    defaultMessage: 'Add shortcut',
    id: 'tiiKDAOran',
    description: 'Tooltip and aria-label for adding a new saved shortcut',
  },
  seeAllShortcuts: {
    defaultMessage: 'See all shortcuts',
    id: 'EbnqvKLvdW',
    description: 'Tooltip and aria-label for opening the full shortcuts library',
  },
  savedShortcutLimitReached: {
    defaultMessage: 'Maximum number of saved shortcuts reached ({max})',
    id: '0+t2KVD0Bu',
    description:
      'Tooltip when the user cannot add more shortcuts because the quota is full',
  },
  savedShortcutQuota: {
    defaultMessage: '{count, number}/{max, number} Saved shortcuts',
    id: 'hOQATrpMre',
    description: 'Shows how many shortcuts are saved out of the maximum allowed',
  },
  editShortcut: {
    defaultMessage: 'Edit',
    id: 'E7auTp3AP6',
    description: 'Tooltip for editing a saved shortcut on the protocols list',
  },
  removeShortcut: {
    defaultMessage: 'Remove',
    id: 'u6ktK1LVvK',
    description: 'Tooltip for removing a custom saved shortcut',
  },
  removeFromMyShortcuts: {
    defaultMessage: 'Remove from my shortcuts',
    id: 'LYrCQKS6+U',
    description: 'Tooltip for removing a built-in shortcut from the saved list',
  },
  noShortcutsYet: {
    defaultMessage: 'No shortcuts yet',
    id: '52olmhyznY',
    description: 'Empty state title when the user has no saved shortcuts',
  },
  addFirstShortcut: {
    defaultMessage: 'Add your first shortcut to get started',
    id: 'XYubx3cVX7',
    description: 'Empty state helper text encouraging the user to add a shortcut',
  },
  closeAria: {
    defaultMessage: 'Close',
    id: 'pAKNdNpFqv',
    description: 'Accessibility label for closing the protocols dialog',
  },
  editProtocolAria: {
    defaultMessage: 'Edit {name}',
    id: 'E4B65P7Bw3',
    description:
      'Accessibility label for editing a specific protocol; name is the protocol title',
  },
  removeProtocolAria: {
    defaultMessage: 'Remove {name}',
    id: '92ocxY788u',
    description:
      'Accessibility label for removing a specific protocol; name is the protocol title',
  },
  teamBadge: {
    defaultMessage: 'Team',
    id: '6MMba5K2FL',
    description: 'Badge label shown on shortcuts authored by a team admin',
  },
  dismissTeamShortcut: {
    defaultMessage: 'Unpin team shortcut',
    id: 'Y8AssA72Jp',
    description: 'Tooltip when hovering remove action on a pinned team shortcut',
  },
});
